// extracted by mini-css-extract-plugin
export default {"paymentSection":"k--z","disabled":"l--z"};